import React from 'react';
import {FormRenderData, Module, Qr} from '@cuatroochenta/co-admin-react-library';

import '@cuatroochenta/co-admin-react-library/lib/index.css';
import './styles/custom.css';
import GenerateQrTicketScreen from './actions/modules/GenerateQrTicketScreen';
import ObtainFileSapScreen from './actions/modules/filesap/ObtainFileSapScreen';
import PendingTicketScreen from './actions/modules/pendingtickets/PendingTicketSreen';
import ImportGTFSScreen from "./actions/modules/importGTFS/ImportGTFSScreen";
import {CreateBackupScreen} from "./actions/modules/createBackups/CreateBackupScreen";
import {ExportMobilisConfigurationScreen} from "./actions/modules/exportMobilisConfiguration/ExportMobilisConfigurationScreen";
import ImportMobilisConfigurationScreen from "./actions/modules/importMobilisConfiguration/ImportMobilisConfigurationScreen";
import {CustomButtonViewScreen} from "./actions/modules/chargehistory/CustomButtonViewScreen";
import {RefundUserTopUpSriButtonViewScreen} from "./actions/modules/usertopupsri/RefundUserTopUpSriButtonViewScreen";

interface Filters {
    [dynamic: string]: string
}

class App extends React.Component {

    private beforeFormView = (entity: string, type: string, data: FormRenderData): React.ReactNode => {
        if (entity === 'linestop' && type === 'view') {
            const url = process.env.REACT_APP_QR_URL_BASE + data.fields.importationId;
            return <Qr url={url}/>;
        }
        return null;
    };

    private customScreenButtonList = (entity: string, type: string, data: any): React.ReactNode => {
        if (entity === 'chargehistory' && type === 'view') {
            return <CustomButtonViewScreen chargehistory={data}/>;
        }
        if (entity === 'usertopupsri' && type === 'view') {
            return <RefundUserTopUpSriButtonViewScreen usertopupsri={data}/>;
        }
        return null;
    };

    private afterFormView = (entity: string, type: string, data: FormRenderData): React.ReactNode => {
        return null;
    };

    private customButtonsList = (entity: string, filters: Filters, orderby: string, order: string): React.ReactNode => {
        return null;
    };

    private afterLoginButton = (): React.ReactNode => {
        return null;
    };

    public render() {
        const languages = [
            {name: 'Español', code: 'es'},
        ]

        return (
            <Module
                actions={[
                    {name: 'GenerateQrTicket', element: <GenerateQrTicketScreen/>},
                    {name: 'FicheroSap', element: <ObtainFileSapScreen/>},
                    {name: 'TicketsPendientesTramitar', element: <PendingTicketScreen/>},
                    {name: 'ImportarGTFS', element: <ImportGTFSScreen/>},
                    {name: 'createBackups', element: <CreateBackupScreen/>},
                    {name: 'exportMobilisConfiguration', element: <ExportMobilisConfigurationScreen/>},
                    {name: 'importMobilisConfiguration', element: <ImportMobilisConfigurationScreen/>}
                ]}
                beforeFormView={this.beforeFormView}
                afterFormView={this.afterFormView}
                customButtonsList={this.customButtonsList}
                customScreenButtonList={this.customScreenButtonList}
                locale={'es'}
                afterLoginButton={this.afterLoginButton}
                languages={languages}
            />
        );
    }

}

export default App;
